<script setup>
const emit = defineEmits([
  'update:custom_field_1_value',
  'update:custom_field_1_custom',
  'update:custom_field_2_value',
  'update:custom_field_2_custom',
  'update:custom_field_3_value',
  'update:custom_field_3_custom',
]);

const props = defineProps({
  custom_fields: {
    required: true,
    default: [],
  },
  custom_field_1_data_custom_enabled: {
    required: true,
  },
  custom_field_1_required: {
    required: true,
  },
  custom_field_1_label: {
    required: true,
  },
  custom_field_1_data: {
    required: true,
  },
  custom_field_1_last_data: {
    required: true,
  },
  custom_field_1_value: {
    required: true,
  },
  custom_field_1_custom: {
    required: true,
  },
  custom_field_2_data_custom_enabled: {
    required: true,
  },
  custom_field_2_required: {
    required: true,
  },
  custom_field_2_label: {
    required: true,
  },
  custom_field_2_data: {
    required: true,
  },
  custom_field_2_last_data: {
    required: true,
  },
  custom_field_2_value: {
    required: true,
  },
  custom_field_2_custom: {
    required: true,
  },
  custom_field_3_data_custom_enabled: {
    required: true,
  },
  custom_field_3_required: {
    required: true,
  },
  custom_field_3_label: {
    required: true,
  },
  custom_field_3_data: {
    required: true,
  },
  custom_field_3_last_data: {
    required: true,
  },
  custom_field_3_value: {
    required: true,
  },
  custom_field_3_custom: {
    required: true,
  },
  errors: {
    required: true,
  },
});
</script>

<template>
  <template v-if="custom_fields.length">
    <hr>

    <template v-for="(field, index) in custom_fields" :key="'custom-fields-' + index">
      <div class="form-group row mb-2">
        <label class="col-4 col-form-label" for="participant_email">
          {{ field.label }}

          <template v-if="field.required">
            <span class="text-red"> *</span>
          </template>
        </label>
        <div class="col-8">
          <component :is="field.type"
              :name="field.name"
              :label="field.label"
              :is-required="field.required"
              :placeholder="field.placeholder"
              :options="field.data"
              :class="{ 'is-invalid': errors[field.name + '_value'] }"
              :modelValue="props[`${field.name}_value`]"
              @update:modelValue="(value) => $emit(`update:${field.name}_value`, value)"
          />

          <template
              v-if="field.type == 'Select' &&
                    props[`${field.name}_data_custom_enabled`] == 1 &&
                    props[`${field.name}_value`] == field.last_data"
          >
            <input
                type="text"
                :name="field.name + '_custom'"
                class="form-control mt-2"
                :class="{ 'is-invalid': errors[field.name + '_custom'] || errors[field.name + '_value'] }"
                required="required"
                :value="props[`${field.name}_custom`]"
                @input="$emit(`update:${field.name}_custom`, $event.target.value)"
            >
          </template>

          <!-- Error message -->
          <div class="invalid-feedback" v-if="errors[field.name + '_value']">
            {{ errors[field.name + '_value'] }}
          </div>

          <div class="invalid-feedback" v-if="errors[field.name + '_custom']">
            {{ errors[field.name + '_custom'] }}
          </div>
        </div>
      </div>
    </template>
  </template>
</template>
